import React, { useEffect, useLayoutEffect } from 'react';
// Prevent annoying error messages because
// components/ui/drawer.ts has not updated their library 'vaul' to be SSR ready
if (process?.env?.ORIGIN_URL?.includes('localhost')) {
  React.useLayoutEffect = React.useEffect;
}

export const useIsomorphicLayoutEffect =
  typeof window !== 'undefined' ? useLayoutEffect : useEffect;
